<script>
import Base from "@/components/RequestDetails/PrePayment.vue";

export default {
  name: "DefaultViewPrePayment",
  extends: Base,
};
</script>

